/**
 * Агрегация статуса оплаты заявки из financialObligations workspace payload.
 * Использует только obligation.status (без пересчёта сумм).
 * Приоритет: OVERDUE → PARTIALLY_PAID → NOT_PAID → PAID.
 */
export type WorkspaceObligationStatusSlice = {
  status?: string | null;
  direction?: string | null;
};

export type ApplicationPaymentAggregateStatus =
  | 'OVERDUE'
  | 'PARTIALLY_PAID'
  | 'NOT_PAID'
  | 'PAID';

const AGGREGATE_PRIORITY: ApplicationPaymentAggregateStatus[] = [
  'OVERDUE',
  'PARTIALLY_PAID',
  'NOT_PAID',
  'PAID',
];

function normalizeObligationStatus(
  raw: string | null | undefined
): ApplicationPaymentAggregateStatus | null {
  const code = String(raw || '').trim().toUpperCase();
  if (!code) return null;
  if (code === 'OVERDUE') return 'OVERDUE';
  if (code === 'PARTIALLY_PAID' || code === 'PARTIAL') return 'PARTIALLY_PAID';
  if (code === 'NOT_PAID' || code === 'OPEN' || code === 'PENDING') return 'NOT_PAID';
  if (code === 'PAID') return 'PAID';
  return null;
}

function isClientIncomeObligation(o: WorkspaceObligationStatusSlice): boolean {
  return String(o.direction || 'INCOME').trim().toUpperCase() === 'INCOME';
}

export function aggregateApplicationPaymentStatus(
  obligations: WorkspaceObligationStatusSlice[] | null | undefined
): ApplicationPaymentAggregateStatus {
  const clientIncome = (obligations ?? []).filter(isClientIncomeObligation);

  /** Workspace отдаёт только не-PAID обязательства; пустой список = всё оплачено. */
  if (clientIncome.length === 0) return 'PAID';

  const statuses = clientIncome
    .map((o) => normalizeObligationStatus(o.status))
    .filter((s): s is ApplicationPaymentAggregateStatus => s != null);

  if (statuses.length === 0) return 'PAID';

  for (const priority of AGGREGATE_PRIORITY) {
    if (statuses.some((s) => s === priority)) return priority;
  }

  return 'NOT_PAID';
}
